import React from 'react';
import { useModalContext } from './ModalContext';
import clsx from 'clsx';
import { t } from '@lingui/core/macro';
import ButtonIcon from '../ButtonIcon';

interface ModalHeaderProps {
  title: string;
  subtitle?: string;
  showCloseButton?: boolean;
  className?: string;
  children?: React.ReactNode;
}

export function ModalHeader({
  title,
  subtitle,
  showCloseButton = true,
  className,
  children,
}: ModalHeaderProps) {
  const { onClose } = useModalContext();

  return (
    <div className={clsx('modal-header', className)}>
      <div className="flex-1">
        <h2 className="modal-title">{title}</h2>
        {subtitle && <p className="text-copy-muted mt-1 text-sm">{subtitle}</p>}
      </div>
      {children}
      {showCloseButton && (
        <ButtonIcon
          icon="close"
          title={t`Close`}
          onClick={onClose}
          className="absolute top-2 right-2"
        />
      )}
    </div>
  );
}
